import { useEffect, useState } from "react";
import toast from "../../utils/toast.js";
import { getProfile } from "../../services/authService.js";

export default function Profile() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    async function fetchProfile() {
      try {
        const res = await getProfile();
        if (isMounted && res.success) {
          setProfile(res.data);
        }
      } catch (err) {
        toast.error(err.response?.data?.message || "Couldn't load your profile.");
      } finally {
        if (isMounted) setLoading(false);
      }
    }

    fetchProfile();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      <main className="dash-content">
        <section className="dash-section active" data-section="profile">
          <div className="section-head-row">
            <h2>Profile</h2>
          </div>
          {loading ? (
            <div className="profile-card">Loading your profile...</div>
          ) : (
            <div className="profile-page-grid">
              <div className="profile-summary-card">
                <div className="profile-avatar">
                  {(profile?.name || "?").trim().charAt(0).toUpperCase()}
                </div>
                <div className="profile-summary-name">{profile?.name}</div>
                <span className="badge-live" style={{ display: "inline-block" }}>
                  {profile?.role === "owner" ? "Fleet Owner" : "Customer"}
                </span>
                <div className="profile-summary-meta">
                  <div className="profile-summary-meta-row">
                    <span>📱</span> <span>{profile?.mobile}</span>
                  </div>
                  {profile?.email && (
                    <div className="profile-summary-meta-row">
                      <span>✉️</span> <span>{profile.email}</span>
                    </div>
                  )}
                </div>
              </div>

              <form className="profile-card" id="profileForm">
                <div className="field">
                  <label htmlFor="profileName">Full name</label>
                  <input
                    type="text"
                    id="profileName"
                    defaultValue={profile?.name || ""}
                  />
                </div>
                <div className="field-row-2">
                  <div className="field">
                    <label htmlFor="profileMobile">Mobile number</label>
                    <input
                      type="tel"
                      id="profileMobile"
                      defaultValue={profile?.mobile || ""}
                      disabled
                    />
                    <p className="field-hint">
                      Mobile number can't be changed — contact support if this is
                      incorrect.
                    </p>
                  </div>
                  <div className="field">
                    <label htmlFor="profileEmail">
                      Email <span className="optional-tag">(optional)</span>
                    </label>
                    <input
                      type="email"
                      id="profileEmail"
                      placeholder="you@example.com"
                      defaultValue={profile?.email || ""}
                    />
                  </div>
                </div>
                <div className="field">
                  <label>Account type</label>
                  <span className="badge-live" style={{ display: "inline-block" }}>
                    {profile?.role === "owner" ? "Fleet Owner" : "Customer"}
                  </span>
                </div>
              </form>
            </div>
          )}
        </section>
      </main>
    </>
  );
}
